import type { User } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';
import { hasSomeRole, Role } from '../utils/user';

const SOCKET_PRINT = 'socket-print';
const LAUNCH_ONLY = 'launch-only';

const hasCapability = (user: User | null | undefined, capability: string) =>
  ((user?.profile as { ais_capabilities?: string } | undefined)?.ais_capabilities?.split(' ') ?? []).includes(capability);

// An AIS session whose vendor prints over the socket, for the role labrador-api takes prints from; it sends to the session of the link redeemed last
export const useSocketPrint = (): boolean => {
  const user = useAuth().user;
  return hasCapability(user, SOCKET_PRINT) && hasSomeRole([Role.ROLE_LR_USER], user);
};

// Anforderungen of this session come from the AIS only
export const useLaunchOnly = (): boolean => hasCapability(useAuth().user, LAUNCH_ONLY);
